@for (error of fcErrors; track $index) {
  <div class="fields__error">
    {{ validationErrors[error] || error }}
  </div>
}
